import { render, staticRenderFns } from "./studenthome.vue?vue&type=template&id=7790ee3a&scoped=true"
import script from "./studenthome.vue?vue&type=script&lang=js"
export * from "./studenthome.vue?vue&type=script&lang=js"
import style0 from "./studenthome.vue?vue&type=style&index=0&id=7790ee3a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7790ee3a",
  null
  
)

export default component.exports